import { createSlice } from '@reduxjs/toolkit'

interface AgentAssistantState {
  agentAssistant: any,
  isLoading: boolean,
  error: string | null
}

const initialState = { 
    agentAssistant: null, 
    isLoading: false,
    error: null
} as AgentAssistantState

const agentAssistantSlice = createSlice({
  name: 'agentAssistant',
  initialState,
  reducers: {
    setAgentAssistant(state, action) {
        state.agentAssistant = action.payload
    }
   }
})

export const { setAgentAssistant } = agentAssistantSlice.actions
export default agentAssistantSlice.reducer